import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useChat } from '../../context/ChatContext';
import ChatSidebar from './ChatSidebar';
import ChatHeader from './ChatHeader';
import ChatMessages from './ChatMessages';
import ChatInput from './ChatInput';
import './ChatPage.css';

/**
 * Main chat page component
 * Manages the overall layout and state for the chat interface
 */
function ChatPage() {
  const { t } = useTranslation();
  const {
    loadBots,
    createNewSession,
    currentSessionId,
    bots,
    botsLoading,
    error,
    clearError,
  } = useChat();

  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Load bots on mount; sessions load automatically via useEffect in ChatContext when currentBotId changes
  useEffect(() => {
    loadBots();
  }, [loadBots]);

  // Create initial session if none exists and bots are loaded
  useEffect(() => {
    if (!currentSessionId && !botsLoading && bots.length > 0) {
      createNewSession();
    }
  }, [currentSessionId, botsLoading, bots, createNewSession]);

  // Zero-bot blocked state
  const noBotAccess = !botsLoading && bots.length === 0;

  return (
    <div className="chat-page">
      {/* Sidebar */}
      <ChatSidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      {/* Main chat area */}
      <div className="chat-main">
        {/* Header */}
        <ChatHeader onMenuClick={() => setSidebarOpen(true)} />

        {/* Error banner */}
        {error && (
          <div className="error-banner">
            <span>{error}</span>
            <button onClick={clearError} aria-label="Close error">×</button>
          </div>
        )}

        {noBotAccess ? (
          <div className="no-bot-access">
            <p>{t('botSelector.noBotAccess')}</p>
          </div>
        ) : (
          <>
            {/* Messages */}
            <ChatMessages />

            {/* Input */}
            <ChatInput />
          </>
        )}
      </div>
    </div>
  );
}

export default ChatPage;
